<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), {
  color: "#43464E",
});
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M22.483 9.1534C22.2784 8.94887 21.9471 8.94887 21.7426 9.1534L15.8182 15.0778L9.89381 9.1534C9.68927 8.94887 9.35792 8.94887 9.1534 9.1534C8.94888 9.35794 8.94887 9.68929 9.1534 9.89381L15.0778 15.8182L9.1534 21.7426C8.94887 21.9471 8.94887 22.2784 9.1534 22.483C9.35794 22.6875 9.68929 22.6875 9.89381 22.483L15.8182 16.5586L21.7426 22.483C21.9471 22.6875 22.2784 22.6875 22.483 22.483C22.6875 22.2784 22.6875 21.9471 22.483 21.7426L16.5586 15.8182L22.483 9.89381C22.6875 9.68928 22.6875 9.35792 22.483 9.1534Z"
      :fill="color"
    />
  </svg>
</template>
